export default __webpack_public_path__ + "static/media/panel-ac-250x250.c2c01222.jpg";